import React, { useMemo } from 'react';
import { Select } from 'antd';
import useCurrencyStore from '../../Store/currencyStore';
import './index.css';

const NavbarCurrencySelect = ({ className = '', size = 'middle', showLabel = false }) => {
    const selectedCurrency = useCurrencyStore((state) => state.selectedCurrency);
    const availableCurrencies = useCurrencyStore((state) => state.availableCurrencies);
    const setCurrencyByCode = useCurrencyStore((state) => state.setCurrencyByCode);

    const currencyOptions = useMemo(
        () =>
            (availableCurrencies?.length ? availableCurrencies : [selectedCurrency])
                .filter(Boolean)
                .map((c) => ({
                    value: c.currencyCode,
                    label: `${c.symbol ? `${c.symbol} ` : ''}${c.currencyCode}`,
                })),
        [availableCurrencies, selectedCurrency]
    );

    return (
        <div className={`navbar-currency-select flex items-center gap-1.5 ${className}`}>
            {showLabel ? (
                <span className='navbar-currency-select__label text-xs whitespace-nowrap'>Currency</span>
            ) : null}
            <Select
                value={selectedCurrency?.currencyCode || 'USD'}
                options={currencyOptions}
                onChange={(code) => setCurrencyByCode(code)}
                popupMatchSelectWidth={false}
                className='navbar-currency-select__control min-w-[88px]'
                size={size}
                showSearch
                optionFilterProp='label'
                aria-label='Select currency'
            />
        </div>
    );
};

export default NavbarCurrencySelect;
